<template>
    <b-card no-body class="card-challenges-picture">
      <!-- <b-button :to="parent + '/sub/' + link"> -->
      <b-button>
        
        <div class="header" :style="{'background-image': `url(${item.src})`}">
          <div class="top-left">
            <p class="subtitle">
              <PuSkeleton :loading="isLoading" :count="1" width="80px">  
                {{subtitle}}
              </PuSkeleton>
            </p>
            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" height="40px"  width="120px">                                            
                {{title}}
              </PuSkeleton>
            </p>
          </div>

          <div class="bottom-right target green">
              {{targetTitle}}
          </div>
        </div>

        <div class="footer">


          <div class="left">

            <div class="head">
              {{ranking}}
            </div>
            <div class="numbers">
              <PuSkeleton :loading="isLoading" :count="1" height="30px" width="60%">                                            
                  <div class="target green mr-2">
                    {{target}}
                  </div>
                  <div class="big">{{rankingResult}}</div>
                  <div class="small"> / {{rankingNumber}}</div>
              </PuSkeleton>
            </div>

          </div>

          <div class="right">

            <div class="head">
            {{score}}
            </div>
            <div class="big">
              <PuSkeleton :loading="isLoading" :count="1" height="30px" width="100px">
                {{scoreNumber}}
              </PuSkeleton>
            </div>
          </div>

        </div>

      </b-button>
    </b-card>
</template>


<script>

//
export default {
  name: "CardChallengesPicture",
  components:{ 
  },
  props:{
    subtitle:{
      type:String,
      default:'Jeu concours'
    },
    title:{
      type:String,
      default:'Pura Vida'
    },
    targetTitle:{
      type:String,
      default:'En cours'
    },
    ranking:{
      type:String,
      default:'Classement'
    },
    rankingNumber:{
      type:String,
      default:'83'
    },
    rankingResult:{
      type:String,
      default:'+1'
    },    
    score:{
      type:String,
      default:'score'
    },
    scoreNumber:{
      type:String,
      default:'250 000'
    },
    target:{
      type:String,
      default:'+1'
    },

  },
  data(){
    return {
      isLoading:true,
      item:{
        src:'/img/challenges-img.png'
      },      
    }
  },
  methods : {
  },  
  mounted (){
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>